import React from 'react';
import { PlusSmIcon } from '@heroicons/react/solid';

const InfoButton = ({
  text,
  onClick
}: {
  text: string;
  onClick: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className="flex items-center justify-between w-full text-black py-5 border-t border-b border-grey-300 cursor-pointer"
    >
      <span className="font-bold text-gray-900 uppercase">{text}</span>
      <PlusSmIcon className="h-5 w-5" aria-hidden="true" />
    </div>
  );
};

export default InfoButton;
